var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFooterOne6(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.4062 5.75H3.59375C3.1968 5.75 2.875 6.0718 2.875 6.46875V17.9688C2.875 18.3657 3.1968 18.6875 3.59375 18.6875H19.4062C19.8032 18.6875 20.125 18.3657 20.125 17.9688V6.46875C20.125 6.0718 19.8032 5.75 19.4062 5.75Z",
    stroke: "#3B4443",
    strokeWidth: 1.06481,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0938 5.75V4.3125C15.0938 3.93125 14.9423 3.56562 14.6727 3.29603C14.4031 3.02645 14.0375 2.875 13.6562 2.875H9.34375C8.9625 2.875 8.59687 3.02645 8.32728 3.29603C8.0577 3.56562 7.90625 3.93125 7.90625 4.3125V5.75",
    stroke: "#3B4443",
    strokeWidth: 1.06481,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.125 10.6299C17.5039 12.1464 14.5282 12.9427 11.5 12.938C8.47187 12.9428 5.4963 12.1468 2.875 10.6308",
    stroke: "#3B4443",
    strokeWidth: 1.06481,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0625 10.0625H12.9375",
    stroke: "#3B4443",
    strokeWidth: 1.06481,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterOne6);
export default __webpack_public_path__ + "static/media/footer-one-6.0ad2b909d0b92282b466bf87d1e0b846.svg";
export { ForwardRef as ReactComponent };